import React, { useEffect, useState } from "react";
import { useStyles } from "../style";
import { Button, Grid } from "@material-ui/core";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import "../../../Courses/Maths/playground.css";
import MathKeyboard from "../../../../SharedComponents/VirtualMathKeyboard/MathKeyboard";

const AdminTextQuestions = ({
  options,
  setOptions,
  enableMathMode,
  setEnableMathMode,
}) => {
  const classes = useStyles();

  const handleOptionChange = (index, value) => {
    const newOptions = options.map((option, i) => {
      if (i === index) {
        return { ...option, text: value };
      }
      return option;
    });
    setOptions(newOptions);
  };

  const addOption = () => {
    setOptions([
      ...options,
      {
        text: "",
        correct: 1,
        sequence: options.length + 1,
        disabled: false,
        hasImage: 0,
        imageUploaded: false,
      },
    ]);
  };

  const handleRemoveOption = (index) => {
    let newOptions = options.filter((option, i) => i !== index);
    newOptions = newOptions.map((row, idx) => {
      return {
        ...row,
        sequence: idx + 1,
        answerSequence: idx + 1,
      };
    });
    setOptions(newOptions);
  };

  const handleEnableMathMode = (e) => {
    setEnableMathMode(e.target.checked);
    options[0].haskeyboard = e.target.checked ? 1 : 0;
    setOptions(options);
  };

  useEffect(() => {
    options[0].haskeyboard = enableMathMode ? 1 : 0;
    setOptions(options);
  }, []);

  const renderInput = (option, index) => {
    if (enableMathMode) {
      return (
        <MathKeyboard
          value={option.text}
          onChange={(value) => handleOptionChange(index, value)}
          readonly={option.disabled}
          placeholder={`\\text{Varaition ${index + 1}}`}
          options={{
            style: {
              border: "none",
              height: "100%",
              width: "100%",
              outline: "none",
              padding: "15px",
              display: "flex",
            },
          }}
        />
      );
    } else {
      return (
        <textarea
          rows={1}
          value={option.text}
          onChange={(event) => handleOptionChange(index, event.target.value)}
          placeholder={`Varaition ${index + 1}`}
          className={classes.mcqOption}
          disabled={option.disabled}
        />
      );
    }
  };

  return (
    <React.Fragment>
      <div
        style={{
          overflow: "auto",
        }}
      >
        {options.map((option, index) => (
          <div
            key={index}
            className={`${classes.flex_row} ${classes.alignItemsCenter} mt-2`}
          >
            <div className={classes.mcqOptionContainer}>
              {renderInput(option, index)}
            </div>
            {index > 0 && (
              <div>
                <DeleteOutlineOutlinedIcon
                  onClick={() => handleRemoveOption(index)}
                  style={{
                    color: "#E76B69",
                    cursor: "pointer",
                    margin: "auto 0 auto 10px",
                  }}
                />
              </div>
            )}
          </div>
        ))}
      </div>
      <Grid className={`${classes.flex_row} ${classes.justifyRight} mt-2 mr-4`}>
        <Button
          className={`${classes.addOptionBtn} ${classes.font500} ${classes.font14}`}
          onClick={addOption}
        >
          <strong>Add Variartions +</strong>
        </Button>
      </Grid>
      <div
        style={{
          display: "flex",
          gap: "8px",
          alignItems: "center",
          margin: "16px 0px",
        }}
      >
        <input
          type="checkbox"
          id="virtualKeyboard"
          name="virtualKeyboard"
          checked={enableMathMode}
          onChange={handleEnableMathMode}
        />
        <label for="virtualKeyboard" className="mb-0">
          Enable Virtual Math keyboard
        </label>
      </div>
    </React.Fragment>
  );
};

export default AdminTextQuestions;
